import * as React from 'react';
import { Form, Popup } from 'semantic-ui-react';

import listaComponentes from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/ListaComponentes';

import CorreoElectronico from './CorreoElectronico';

const botonEliminarStyle = { marginTop: '1ex' };

interface Props {
    requerido: boolean;
}

const ListaCorreos = listaComponentes<string, Props>(props => {
    const { requerido, item, onChange, onDelete } = props;

    return (
        <Form.Group>
            <CorreoElectronico
                correo={item}
                onChangeCorreo={correo => {
                    onChange(correo);
                }}
                width='6'
                placeholder='otrocorreo@mail.com'
                required={requerido}
            />
            <Popup
                trigger={
                    <Form.Button
                        type='button'
                        circular
                        compact
                        icon='close'
                        color='red'
                        size='tiny'
                        style={botonEliminarStyle}
                        onClick={onDelete}
                    />
                }
                content='Quitar este correo'
                position='right center'
            />
        </Form.Group>
    );
});
export default ListaCorreos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/CorreosElectronicos/componentes/ListaCorreos.tsx